import { LoginFormData } from '../../../entities/@forms/LoginForm/LoginForm'
import {
    FormErrors,
    FormValidation,
    validateEmailRegex,
    validateForm,
    validateRequiredString,
} from '../../../services/validationService'

export type LoginFormErrors = FormErrors<LoginFormData>;

export const validateLoginFormData = (formData: LoginFormData): FormValidation<LoginFormErrors> => {
    const errors: LoginFormErrors = {
        username: validateEmailRegex(formData.username),
        password: validateRequiredString('password', formData.password),
    }

    return validateForm<LoginFormErrors>(errors)
}
